import React from "react";
import * as MuiIcons from "@mui/icons-material";
import { whyQuinterra } from "../../data/companyData";
import "./SaasSections.css";

function getIcon(name) {
  const Icon = MuiIcons[name] || MuiIcons.Star;
  return <Icon />;
}

export default function WhyQuinterraSection() {
  return (
    <section className="saas-section why-section" id="why-quinterra-section">
      <h2 className="saas-section__title">WHY QUINTERRA</h2>
      <div className="saas-section__body">
        <div className="why-grid">
          {whyQuinterra.map((item) => (
            <div key={item.title} className="why-card">
              <div className="why-card__icon">{getIcon(item.icon)}</div>
              <h3 className="why-card__title">{item.title}</h3>
              <p className="why-card__desc">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
